import { useDispatch, useSelector } from 'react-redux';
import { toggleModal } from '../actions/modalActions';
import { useLocation } from 'react-router-dom';
import paths from '../routes/paths';

const useMoney = modal => {
    const dispatch = useDispatch();
    const location = useLocation();
    const isOpen = useSelector(state => state.ModalReducer[modal]);

    const handleToggleModal = isOpen => {
        dispatch(toggleModal({
            isOpen,
            modal
        }));
    }

    const validPath = () => {
        const { pathname } = location;
        return pathname.indexOf(paths.notFound) === -1 && pathname.indexOf(paths.unSupport) === -1;
    }

    return {
        toggleModal: handleToggleModal,
        isOpen: isOpen && validPath()
    }
}

export default useMoney
